import {createAction} from "@reduxjs/toolkit";

const exampleOutputChanged = createAction<{
	exerciseId: number;
	exampleOutput: string;
}>("exercises/prog/exampleOutputChanged");

export default exampleOutputChanged;
